import { httpGET, httpPATCH, json } from './utils.js';
import { ACTIONS } from '../const';
import {
    getMembership,
    getBySection,
    selectLastPageRead,
} from '../selectors/membership';
import { selectUser } from '../selectors/current_user';

export const getMembershipForSection = sectionId => (dispatch, getState) => {
    const membership = getBySection(getState(), sectionId);
    if (membership != null) {
        return Promise.resolve(membership);
    }

    const uid = selectUser(getState()).id;

    return httpGET(`/api/v3/membership/?section=${sectionId}&user=${uid}`)
        .then(json)
        .then(({ objects: [membership] }) => {
            dispatch({
                type: ACTIONS.SYNC_MEMBERSHIP,
                membership,
            });
            return getBySection(getState(), sectionId);
        });
};

export const saveLastPage = (content, page) => (dispatch, getState) => {
    // this can get called many times at once. The fetch is cached, but n
    // calls produces n promises
    return dispatch(getMembershipForSection(content.section_id)).then(
        membership => {
            // We may be resolving n promises, grab the latest version so only the
            // first one makes it past this point.
            membership = getMembership(getState(), membership.id);
            if (selectLastPageRead(getState(), content.id) == page) {
                return;
            }

            dispatch({
                type: ACTIONS.SET_LAST_PAGE,
                contentId: content.id,
                membershipId: membership.id,
                page,
            });

            // That dispatch should have updated the membership.
            membership = getMembership(getState(), membership.id);
            const lastPages = membership.last_pages;

            return httpPATCH(membership.resource_uri, {
                last_pages: lastPages,
            }).then(json);
        }
    );
};



// WEBPACK FOOTER //
// ./src/actions/membership.js